import React from 'react';

const pressItems = [
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/02/press-release-1.jpg',
    title: 'Utility Company Strengthen',
    subtitle: 'Press Release',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/02/press-release-2.jpg',
    title: 'Voltage Optimization',
    subtitle: 'Press Release',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/02/press-release-3.jpg',
    title: 'Software - Energy Award',
    subtitle: 'Press Release',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/02/press-release-4.jpg',
    title: 'Press Release',
    subtitle: 'Press Release',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/02/press-release-5.jpg',
    title: 'Dr. Sukanta (CEO - INOVAANTAGE)',
    subtitle: 'Press Release',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/02/press-release-6.jpg',
    title: 'Hyderabad Center Inauguration',
    subtitle: 'Press Release',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/02/press-release-7.jpg',
    title: "Dr. Sukanta in Top 10 CEO's",
    subtitle: 'Press Release',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/02/press-release-8.jpg',
    title: 'SBR Technology Excellence Awards',
    subtitle: 'Press Release',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/08/Sukanta-Kumar-Jena-INOVAANTAGE-Interview.webp',
    title: 'Competition but Collaboration: Dr Sukanta Kumar Jena',
    subtitle: 'business aspirations and WGIC’s missione',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/08/109217613.webp',
    title: 'Top Trailblazers: Celebrating Influential Global Business Leaders',
    subtitle: 'Mediawire / Apr 11, 2024, 14:50 IST',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/08/20211118123107.webp',
    title: 'Renewed hope to IT professionals looking for jobs',
    subtitle: 'Last Updated : Nov 18 2021 | 11:30 PM IST',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/08/press.png',
    title: 'Dr Sukanta Kumar Jena felicitated with ‘Champions of Change’ Telengana Award 2021',
    subtitle: '13 April, 2022 10:30 am IST',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/08/6.png',
    title: 'Top 5 Inspiring Business Titans of 2023',
    subtitle: 'Nov 03 2023 | 11:45 PM IST',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/08/10.png',
    title: 'Inovaantage, featured in ET NOW - Greatest Brands & Leaders 2022-23 Asia, Americas & Africa',
    subtitle: '',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/08/12.png',
    title: 'STRATEGY, BRANDING PLATFORMS AND BUSINESS RESEARCH',
    subtitle: 'United Research Services International is part of UWG – United World Group Holdings LLC',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/08/15.png',
    title: 'The Indian Alert: Top 10 CEOs of the year 2021-22',
    subtitle: 'Known or unknown, each CEO on this list is special',
  },
  {
    image: 'https://inovaantage.com/wp-content/uploads/2024/08/18.png',
    title: 'Top 10 CEOs of The Year 2021-22 By The Indian Alert',
    subtitle: 'Feb 03 2022 | 11:30 PM IST',
  },
];

const PressRelease = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Inovaantage</h1>
      <h2 style={styles.subheader}>Press Release</h2>
      <div style={styles.grid}>
        {pressItems.map((item, index) => (
          <div key={index} style={styles.card}>
            <img src={item.image} alt={item.title} style={styles.image} />
            <p style={styles.subtitle}>{item.subtitle}</p>
            <h3 style={styles.title}>{item.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '2rem',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f9f9f9',
  },
  header: {
    textAlign: 'center',
    fontSize: '2.5rem',
    marginBottom: '0.5rem',
  },
  subheader: {
    textAlign: 'center',
    fontSize: '1.5rem',
    marginBottom: '2rem',
    color: '#555',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '1.5rem',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease',
  },
  image: {
    width: '100%',
    height: '200px',
    objectFit: 'cover',
  },
  subtitle: {
    padding: '0 1rem',
    margin: '0.5rem 0 0',
    color: '#999',
    fontSize: '0.9rem',
  },
  title: {
    padding: '0 1rem 1rem',
    margin: 0,
    fontSize: '1.1rem',
    color: '#333',
  },
};

export default PressRelease;
